<div class="grid-x grid-margin-x section">
  <form [formGroup]="form">
    @if (hasFieldNotes('apiNumber')) {
      <div>
        <view-notes [fieldName]="'apiNumber'" [notes]="getFilteredNotes('apiNumber')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      </div>
    }
    <well-selector [organization]="organization" [enableSelections]="enableWellSelection" [reportType]="reportType" (throw)="handleError($event)" (selectedWells)="onWellsSelected($event)"></well-selector>

    <div class="grid-x grid-margin-x padding-bottom-large section">
      <div class="cell small-12 medium-12 large-12 bold">
        Upload Plugging Report (Form 55): <span class="bold">*</span>
      </div>
      <div class="cell small-12 medium-12 large-12">

        @if (hasFieldNotes('uploadedFiles')) {
          <span> <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes></span>
        }
        <upload-view-files [uniqueId]="'uploader'" [files]="uploadedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="uploadedFilesCtrl?.enabled" [allowUpload]="uploadedFilesCtrl?.enabled" (fileRemoved)="onFileDeleted($event)" (newFilesList)="fileAdded($event)">
        </upload-view-files>

      </div>
      @if (isInternal) {
        <hr />
        <div class="cell">
          <label for="receivedDate">Date Plugging Report Received</label>
          <common-date-picker id="receivedDate" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate" [disabled]="form?.get('receivedDate')?.disabled"></common-date-picker>
        </div>
        <div class="cell">
          <label for="plugDate">Plug Date</label>
          <common-date-picker id="plugDate" (dateUpdated)="onDateUpdated($event, 'plugDate')" [initialDate]="plugDate" [disabled]="form?.get('plugDate')?.disabled"></common-date-picker>
        </div>
        <div class="cell">
          <label for="replugDate">Re-Plug Date</label>
          <common-date-picker id="replugDate" (dateUpdated)="onDateUpdated($event, 'replugDate')" [initialDate]="replugDate" [disabled]="form?.get('replugDate')?.disabled"></common-date-picker>
        </div>
      }
    </div>
    @if (!isInReview && wellIsSelected) {
      <div class="grid-x grid-margin-x ">
        @switch (true) {
          @case (!isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              <p>By clicking submit, I certify that the information provided is true and accurate, to the best of my knowledge.</p>
              <span class="minor-margin-right">
                <button class="button" (click)="saveForLater()">Save for Later</button>
              </span>
              @if (wellIsSelected) {
                <span class="minor-margin-right">
                  <button class="button" (click)="submit()" [disabled]="!filesUploaded">Submit</button>
                </span>
              }
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
          @case (isInternal) {
            <div class="large-12 medium-12 small-12 text-align-center">
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" (click)="saveForLater()">Save for Later</button>
                </span>
              }
              @if (!isApproved && !isInCorrections) {
                <span class="minor-margin-right">
                  <button class="button" [disabled]="!filesUploaded" (click)="onAccept()">Accept</button>
                </span>
              }
              <span>
                <button class="button" (click)="cancel()">Cancel</button>
              </span>
            </div>
          }
        }
      </div>
    }

  </form>
</div>
<hr />
